import { getAPI, postAPI, putAPI } from "../..";
import config from "../../../utils/config";
import {
  GET_NOTIFICATION_URL,
  READ_ALL_NOTIFICATION_URL,
  SEND_NOTIFICATION_URL,
} from "../../url";

export const getNotificationAPI = async (page_no = 1, per_page = 10) => {
  let response = await getAPI(
    config.quicklinkUrl +
      GET_NOTIFICATION_URL +
      `?page=${page_no}&per_page=${per_page}`,
    false
  );
  return response;
};

export const sendNotificationAPI = async (payload) => {
  let response = await postAPI(
    config.quicklinkUrl + SEND_NOTIFICATION_URL,
    payload
  );
  return response;
};

export const markAsReadNotificationAPI = async (payload) => {
  let response = await putAPI(
    config.quicklinkUrl + READ_ALL_NOTIFICATION_URL,
    payload
  );
  return response;
};
